import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import DenverSlideshow from './DenverSlideshow';
import DenverDonorList from './DenverDonorList';

import { getDonorsFromFolder } from '../../../utils/donorHelpers';
import { createFolderTree } from '../../../utils/shared.js';

const DONOR_LIST_CYCLE_SECONDS_DEFAULT = 10;
const SLIDESHOW_CYCLE_SECONDS_DEFAULT = 15;

class DenverContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      donorsLeft: [],
      donorsRight: [],
      slideshowImagesLeft: [],
      slideshowImagesRight: []
    };

    this._leftDonorListRef = null;
    this._rightDonorListRef = null;

    this._leftSlideshowRef = null;
    this._rightSlideshowRef = null;
  }

  componentDidMount() {
    this.timedCycle();
    this._cycleInterval = setInterval(() => {
      this.timedCycle();
    }, 1000);

    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }
  
  handleKeyDown = (event) => {
    switch (event.key) {
      case "s":
        //console.log(this.props);
        //console.log('donors', this.props.donors);
        break;
      default:
        break;
    }
  }

  timedCycle = () => {
    
    //this._leftDonorListRef.timedCycle();
    //this._rightDonorListRef.timedCycle();

    //this._leftSlideshowRef.timedCycle();
    //this._rightSlideshowRef.timedCycle();
  }

  render() {

    const height = window.innerHeight;
    const width = window.innerWidth / 2;

    const donorListCommonProps = {
      defaultCycleTime: DONOR_LIST_CYCLE_SECONDS_DEFAULT,
      width: width,
      height: height,
      content: this.props.content,
      screen: this.props.screen,

      fsTitleModifier: 0.045,
      fsSubheaderModifier: 0.023,
      fsNamesModifier: 1,
      yOffsetTitleModifier: 0.033,
      yOffsetSubheaderModifier: 0.12,
      yOffsetSubheaderUnderlineModifier: 0.22,
      subheaderUnderlineWidthModifier: 0.9,

      yOffsetNamesModifier: 0.27,
      titleWidthModifier: 0.42,
      descriptionWidthModifier: 0.82,
      descriptionLineHeightModifier: 0.0034,

      targetHeight: 1080

    };
    
    return (
      <div>
        <DenverSlideshow
          images={this.props.slideshowImagesLeft}
          cycleOverrides={[]}
          defaultCycleTime={SLIDESHOW_CYCLE_SECONDS_DEFAULT}
          ref={ref => this._leftSlideshowRef = ref}
          height={height}
          width={width}
          screen={this.props.screen}
          screenOffset={0}          
        />

        <DenverDonorList
          {...donorListCommonProps}
          ref={ref => this._leftDonorListRef = ref}
          style={{ position: 'absolute', height: '70vh', left: width * .04125, width: width - (width * .04125 * 2), float: "left" }}
          left={0}
          donorCategories={this.props.donorsLeft}
          listTopOffset={window.innerHeight * .26}
          listWidth={window.innerWidth * .45}
          listHeight={window.innerHeight * .7}
          subHeaderFontSize={"2.3vh"}
        />

        <DenverSlideshow
          images={this.props.slideshowImagesRight}
          cycleOverrides={[]}
          defaultCycleTime={SLIDESHOW_CYCLE_SECONDS_DEFAULT}
          ref={ref => this._rightSlideshowRef = ref}
          height={height}
          width={width}
          screenOffset={width}
          screen={this.props.screen}
        />

        <DenverDonorList
          {...donorListCommonProps}
          donorCategories={this.props.donorsRight}
          ref={ref => this._rightDonorListRef = ref}
          left={width}
          style={{ position: 'absolute', height: '70vh', left: width * .04125, width: width - (width * .04125 * 2), float: "none" }}
          listTopOffset={window.innerHeight * .26}
          listWidth={window.innerWidth * .45}
          listHeight={window.innerHeight * .7}
          subHeaderFontSize={"2.3vh"}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const getFolder = type => state.content.story_categories.find((cat) => {
    return _.get(cat, 'contents.custom_fields.folder_type.val.value') === type;
  });

  const attractLoopLeft = getFolder('attract_loop_donor_wall_left');
  const attractLoopRight = getFolder('attract_loop_donor_wall_right');

  const createTree = (attractLoop) => {
    const folderTree = createFolderTree(
      state.content.story_categories,
      state.content.folder_modules,
      null,
      state.content.stories,
      state.content.dm_active,
      attractLoop.name,
      'sorting_name'
    );
    folderTree.children.map(x=> {
      let folder_module = _.find(state.content.folder_modules, {id: x.folder_module_id});
      x.folder_module_rank = folder_module.rank
      return null;
    })
  
    folderTree.children = _.orderBy(folderTree.children, "folder_module_rank", "asc");
    return folderTree;
  };

  const attractLoopTreeLeft = createTree(attractLoopLeft);
  const attractLoopTreeRight = createTree(attractLoopRight);

  const getDonors = attractLoopTree => attractLoopTree.children.map(child => {
    return {
      ...child,
      donors: getDonorsFromFolder(state.donors, state.content.folder_modules, child.id)
    };
  });

  const donorsLeft = getDonors(attractLoopTreeLeft);
  const donorsRight = getDonors(attractLoopTreeRight)

  _.forEach(donorsLeft, cat => {
    cat.donors = _.orderBy(cat.donors, 'sorting_name')
  })
  _.forEach(donorsRight, cat => {
    cat.donors = _.orderBy(cat.donors, 'sorting_name')
  })

  const donorWall = getFolder('donor_wall');
  const slideshowImagesLeft = [];
  const slideshowImagesRight = [];
  
  if (Array.isArray(donorWall.contents.images)) {
    if (donorWall.contents.images[0]) {
      slideshowImagesLeft.push(donorWall.contents.images[0]);
    }
    if (donorWall.contents.images[1]) {
      slideshowImagesRight.push(donorWall.contents.images[1]);
    }
  }

  return {
    // active_module: active_module,
    content: state.content,
    // contentHasErrored: state.contentHasErrored,
    // contentIsLoading: state.contentIsLoading,
    donors: state.donors,
    // donorsHasErrored: state.donorsHasErrored,
    // donorsIsLoading: state.donorsIsLoading,
    screen: state.screen,
    options: state.options,
    screensNumber: state.screensNumber,
    donorsLeft: donorsLeft,
    donorsRight: donorsRight,
    slideshowImagesLeft,
    slideshowImagesRight
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};


export default connect(mapStateToProps, mapDispatchToProps)(DenverContainer);


// WEBPACK FOOTER //
// ./src/Components/Theme/Denver/DenverDonorListsContainer.js